import { createContext } from "react";

const TablesContext = createContext()

export default TablesContext